export default {
  dbu_common_quarter: '季度',
  dbu_common_mobile_game: '手游',
  dbu_common_pc_game: '端游',
  dbu_common_console_game: '主机游戏',
  dbu_common_combine_game: '端游 & 主机游戏',
  dbu_common_days: '天',

  dbu_common_genre_action: '动作',
  dbu_common_genre_adventure: '冒险',
  dbu_common_genre_casual: '休闲',
  dbu_common_genre_rpg: '角色扮演',
  dbu_common_genre_racing: '竞速',
  dbu_common_genre_shooter: '射击',
  dbu_common_genre_simulation: '模拟',
  dbu_common_genre_software: '软件',
  dbu_common_genre_sports: '体育',
  dbu_common_genre_strategy: '策略',

  dbu_common_upload: '上传',
  dbu_common_download: '下载',
  dbu_common_save: '保存',
  dbu_common_back: '返回',
  dbu_common_preview: '预览',
  dbu_common_share: '分享',
  dbu_common_publish: '发布',
  dbu_common_draft: '草稿',
  dbu_common_switch_en: '切换为英文',
  dbu_common_switch_cn: '切换为中文',
  dbu_common_delete_success_tips: '删除成功',
  dbu_common_delete_failure_tips: '删除失败',
  dbu_common_update_time: '更新时间',
  dbu_common_reports: '报告',
  dbu_common_report: '报告',
  dbu_common_cover: '封面',
  dbu_common_upload_img: '上传图片',
  dbu_common_upload_img_placeholder: '请上传封面',
  dbu_common_delete_confirm_title: '你确定要删除这个文件吗？',
  dbu_common_delete_confirm_desc: '删除后将无法恢复。',
};
